import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as owner_remittances_api from '../Api/owner_remittances_api';



///types
const moment = require('moment')

export interface State {

    owner_mail_list: any;
    owner_mail_search: any;
    owner_mail_loading: boolean;

}
const initialState: State = {

    owner_mail_list: [],
    owner_mail_search: { tatemono_name: "", name: "", user_id: 0, flg: 0 },
    owner_mail_loading: false,

}



///action 
const actionCreator = actionCreatorFactory();


export const get_owner_mail_list = actionCreator('GET_OWNER_MAIL_LIST');
export const change_owner_mail_list = actionCreator("CHANGE_OWNER_MAIL_LIST");

export const change_owner_mail_search = actionCreator<any>("CHANGE_OWNER_MAIL_SEARCH");

export const send_owner_mail = actionCreator('SEND_OWNER_MAIL');

export const change_owner_mail_loading = actionCreator<boolean>('CHANGE_OWNER_MAIL_LOADING');


export const ownerMailReducer = reducerWithInitialState(initialState)
    .case(change_owner_mail_list, (state, payload) => ({ ...state, owner_mail_list: payload }))
    .case(change_owner_mail_search, (state, payload) => ({ ...state, owner_mail_search: payload }))
    .case(change_owner_mail_loading, (state, payload) => ({ ...state, owner_mail_loading: payload }))






// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const ownerMailSaga = [

    takeEvery('GET_OWNER_MAIL_LIST', handle_get_owner_mail_list),
    takeEvery('SEND_OWNER_MAIL', handle_send_owner_mail),


];



function* handle_get_owner_mail_list(action: any) {

    const { payload, error } = yield call(owner_remittances_api.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {


        yield put(change_owner_mail_list(payload))




    } else {
        alert(error)

    }



}



function* handle_send_owner_mail(action: any) {

    yield put(change_owner_mail_loading(true))
    const { payload, error } = yield call(owner_remittances_api.send, {});

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {


        yield put(change_owner_mail_list(payload))

        yield put(change_owner_mail_loading(false))


    } else {
        alert(error)

    }



}